export const homeObjOne = {
  lightBg: false,
  lightText: true,
  lightTopLine: true,
  lightTextDesc: true,
  topLine: 'Our Solutions',
  headline: 'Innovative solutions across key industries',
  description:
    'We deliver impactful solutions in agriculture, technology, infrastructure, and services designed to drive growth and create sustainable employment.',
  buttonLabel: 'Explore More',
  imgStart: '',
  img: require('../../images/solutions.jpg'),
  alt: 'Solutions'
};

export const homeObjTwo = {
  lightBg: true,
  lightText: false,
  lightTopLine: true,
  lightTextDesc: false,
  topLine: 'Agriculture',
  headline: 'Modern farming and agribusiness solutions',
  description:
    'From crop production to processing, we support the full agricultural value chain to ensure food security and economic growth.',
  buttonLabel: 'Learn More',
  imgStart: 'start',
  img: require('../../images/agriculture.jpg'),
  alt: 'Agriculture'
};

export const homeObjThree = {
  lightBg: false,
  lightText: true,
  lightTopLine: true,
  lightTextDesc: true,
  topLine: 'Technology',
  headline: 'Digital innovation and smart systems',
  description:
    'We build and implement technology that improves efficiency, enhances productivity, and supports modern businesses.',
  buttonLabel: 'Discover',
  imgStart: '',
  img: require('../../images/technology.jpg'),
  alt: 'Technology'
};

export const homeObjFour = {
  lightBg: true,
  lightText: false,
  lightTopLine: true,
  lightTextDesc: false,
  topLine: 'Infrastructure',
  headline: 'Building systems that support development',
  description:
    'Our infrastructure projects focus on construction, logistics, and industrial development to enable long-term growth.',
  buttonLabel: 'View Projects',
  imgStart: 'start',
  img: require('../../images/infrastructure.jpg'),
  alt: 'Infrastructure'
};